import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icons = _resolveComponent("Icons")!

  return (_openBlock(), _createBlock("div", {
    class: ["rounded-full px-2 border font-medium flex items-center gap-x-1 text-sm", [
      _ctx.increase
        ? 'border-green-lp-100 text-green-lp-100 bg-green-lp-500'
        : 'border-red-lp-2000 text-red-lp-2000 bg-red-lp-1300'
    ]]
  }, [
    _createVNode(_component_Icons, {
      name: "arrow-up",
      class: "w-2.5",
      style: !_ctx.increase ? 'transform: rotate(180deg)' : ''
    }, null, 8, ["style"]),
    _createVNode("span", null, _toDisplayString(_ctx.increase ? "+" : "") + _toDisplayString(_ctx.formatNumber(_ctx.progress)), 1)
  ], 2))
}